<script setup>
import Button from "~/components/ui/Button.vue";
import {ModalsContainer, useModal} from "vue-final-modal";
import SubscribeModal from "~/components/modals/SubscribeModal.vue";

const publicSiteData = useState('publicSiteData');
const { theme } = useTheme();

const hasAddress = computed(() => {
    return publicSiteData.value?.addr_1
        || publicSiteData.value?.addr_2
        || publicSiteData.value.addr_city;
});

const openSubscribeModal = () => {
    const { open, close } = useModal({
        component: SubscribeModal,
        attrs: {
            welcomeMessage: 'hello there!',
            onClose() {
                close();
            }
        }
    });
    open();
};
</script>

<template>
    <footer class="text-white py-8 md:py-12 px-4" :style="{ backgroundColor: theme.bg }">
        <div class="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-8 md:gap-6">

            <!-- contact info -->
            <div class="flex flex-col gap-y-2 text-light">
                <h2 class="font-medium text-lg break-words">{{ publicSiteData.organization_display_name }}</h2>

                <div v-if="hasAddress" class="text-sm">
                    <div v-if="publicSiteData.addr_1">{{ publicSiteData.addr_1 }}</div>
                    <div v-if="publicSiteData.addr_1">{{ publicSiteData.addr_2 }}</div>
                    <div v-if="publicSiteData.addr_city || publicSiteData.addr_state" class="flex flex-wrap gap-1">
                        <span v-if="publicSiteData.addr_city">{{ publicSiteData.addr_city }},</span>
                        <span>{{ publicSiteData.addr_state }}</span>
                        <span>{{ publicSiteData.addr_zip }}</span>
                    </div>
                </div>

                <div v-if="publicSiteData.phone" class="text-sm flex gap-1.5 items-center tracking-wide">
                    <font-awesome :icon="['far', 'phone']" />
                    <span>{{ publicSiteData.phone }}</span>
                </div>
                <div v-if="publicSiteData.email" class="text-sm flex gap-1.5 items-center">
                    <font-awesome :icon="['far', 'envelope']" />
                    <span>{{ publicSiteData.email }}</span>
                </div>
            </div>

            <!-- Links -->
            <div class="md:col-span-2 lg:col-span-2">
                <div v-if="publicSiteData.links.length">
                    <h2 class="font-medium text-lg mb-2">Quick links</h2>
                    <div :class="[
                    'text-sm grid gap-x-4 md:gap-x-8 gap-y-2',
                    publicSiteData.links.length > 4 ? 'grid-cols-1 sm:grid-cols-2 sm:grid-flow-col sm:grid-rows-4' : 'grid-cols-1'
                ]">
                        <div v-for="link in publicSiteData.links">
                            <a :href="link.url" target="_blank" class="text-white hover:text-gray-400 inline-flex items-center" :aria-label="`${link.label} (opens in new tab)`">
                                <span v-text="link.label" class="mr-2"></span>
                                <font-awesome class="h-3 w-3 flex-shrink-0" :icon="['far', 'arrow-up-right-from-square']"/>
                            </a>
                        </div>
                    </div>
                </div>
            </div>


            <div class="mt-4 md:mt-0">
                <div class="flex items-center gap-2 justify-start lg:justify-end">
                    <span class="text-white font-light text-sm">Powered by</span>
                    <a href="https://boardable.com" target="_blank" aria-label="Powered by Boardable (opens in new tab)"><img src="/img/boardable_logo_white.svg" class="w-20 md:w-24" alt="Boardable logo" /></a>
                </div>
                <div>
                    <Button type="secondary" size="small" class="!rounded-3xl !px-4 !float-right !mt-6 !py-0" @click="openSubscribeModal">Subscribe to updates</Button>
                </div>
            </div>
        </div>
        <ModalsContainer />
    </footer>
</template>